import { disposables as M } from '../utils/disposables.js';
import { getOwnerDocument as b } from '../utils/owner.js';
import { useIsTopLayer as L } from './use-is-top-layer.js';
import { useIsoMorphicEffect as T } from './use-iso-morphic-effect.js';
let f = new Map(),
  u = new Map();
function h(t) {
  var e;
  let r = (e = u.get(t)) != null ? e : 0;
  return u.set(t, r + 1), r !== 0 ? () => m(t) : (f.set(t, {
    "aria-hidden": t.getAttribute("aria-hidden"),
    inert: t.inert
  }), t.setAttribute("aria-hidden", "true"), t.inert = !0, () => m(t));
}
function m(t) {
  var i;
  let r = (i = u.get(t)) != null ? i : 1;
  if (r === 1 ? u.delete(t) : u.set(t, r - 1), r !== 1) return;
  let e = f.get(t);
  e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, f.delete(t));
}
function y(t) {
  let {
    allowed: r,
    disallowed: e
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let i = L(t, "inert-others");
  T(() => {
    var d, c;
    if (!i) return;
    let a = M();
    for (let n of (d = e == null ? void 0 : e()) != null ? d : []) n && a.add(h(n));
    let s = (c = r == null ? void 0 : r()) != null ? c : [];
    for (let n of s) {
      if (!n) continue;
      let l = b(n);
      if (!l) continue;
      let o = n.parentElement;
      for (; o && o !== l.body;) {
        for (let p of o.children) s.some(E => p.contains(E)) || a.add(h(p));
        o = o.parentElement;
      }
    }
    return a.dispose;
  }, [i, r, e]);
}
export { y as useInertOthers };